import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Teleport as _Teleport, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_icon = _resolveComponent("t-icon")!
  const _component_t_loading = _resolveComponent("t-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'fixed' && _ctx.modelValue)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", _mergeProps({
            class: _ctx.getClasses.wrap
          }, _ctx.$attrs, {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
          }), [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClasses.content)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClasses.iconWrap)
              }, [
                (_ctx.src !== 'loading')
                  ? (_openBlock(), _createBlock(_component_t_icon, {
                      key: 0,
                      size: _ctx.size,
                      theme: _ctx.getTheme,
                      "icon-name": _ctx.src
                    }, null, 8, ["size", "theme", "icon-name"]))
                  : _createCommentVNode("", true),
                (_ctx.src === 'loading')
                  ? (_openBlock(), _createBlock(_component_t_loading, {
                      key: 1,
                      theme: _ctx.getTheme,
                      size: _ctx.size
                    }, null, 8, ["theme", "size"]))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_ctx.getClasses.title)
                  }, _toDisplayString(_ctx.title), 3))
                : _createCommentVNode("", true),
              (_ctx.description)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.getClasses.description)
                  }, _toDisplayString(_ctx.description), 3))
                : _createCommentVNode("", true)
            ], 2)
          ], 16)
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === 'static' && _ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 1,
          class: _ctx.getClasses.wrap
        }, _ctx.$attrs, {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
        }), [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClasses.content)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClasses.iconWrap)
            }, [
              (_ctx.src !== 'loading')
                ? (_openBlock(), _createBlock(_component_t_icon, {
                    key: 0,
                    size: _ctx.size,
                    theme: _ctx.getTheme,
                    "icon-name": _ctx.src
                  }, null, 8, ["size", "theme", "icon-name"]))
                : _createCommentVNode("", true),
              (_ctx.src === 'loading')
                ? (_openBlock(), _createBlock(_component_t_loading, {
                    key: 1,
                    theme: _ctx.getTheme,
                    size: _ctx.size
                  }, null, 8, ["theme", "size"]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.getClasses.title)
                }, _toDisplayString(_ctx.title), 3))
              : _createCommentVNode("", true),
            (_ctx.description)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(_ctx.getClasses.description)
                }, _toDisplayString(_ctx.description), 3))
              : _createCommentVNode("", true)
          ], 2)
        ], 16))
      : _createCommentVNode("", true)
  ], 64))
}